function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_Info_73316",
  transform: "translate(-35 -11.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M40.767,14.9a1.9,1.9,0,0,0,0-2.812,2.215,2.215,0,0,0-3,0,1.894,1.894,0,0,0,0,2.812,2.232,2.232,0,0,0,3,0ZM39.81,27.811c.749-.35,1.145-1.009.756-1.31-.224-.173-.518.114-.732.114a1.57,1.57,0,0,1-.971-.227,1.056,1.056,0,0,1-.279-.855,4.551,4.551,0,0,1,.084-.737,8.884,8.884,0,0,1,.2-.869l.89-3.152a5.261,5.261,0,0,0,.179-.953c.031-.349.048-.591.048-.727a2.074,2.074,0,0,0-.7-1.62,2.88,2.88,0,0,0-1.985-.624,4.6,4.6,0,0,0-1.517.255c-1.043.366-.811,1.275-.58,1.275a1.4,1.4,0,0,1,.952.239,1.137,1.137,0,0,1,.253.844,3.969,3.969,0,0,1-.084.743c-.055.27-.119.558-.2.861l-.895,3.164q-.114.5-.172.894A5.779,5.779,0,0,0,35,25.9a2.05,2.05,0,0,0,.718,1.608,3.2,3.2,0,0,0,2.081.818A5.265,5.265,0,0,0,39.81,27.811Z",
  fill: "#25a4b4"
}));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6.39,
    height: 16.826,
    viewBox: "0 0 6.39 16.826",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.ecfea05d.svg";
export { ForwardRef as ReactComponent };